(function () {
  function format() {
    var now = new Date();
    var date = now.toLocaleDateString('en-GB');
    var time = now.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
    var offset = -now.getTimezoneOffset() / 60;
    var tz = 'GMT' + (offset >= 0 ? '+' : '') + offset;
    return date + ' · ' + time + ' ' + tz;
  }
  function tick() {
    var els = document.querySelectorAll('[data-known-datetime]');
    if (!els.length) return;
    var s = format();
    for (var i = 0; i < els.length; i++) els[i].textContent = s;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  } else {
    tick();
  }
  setInterval(tick, 30000);
})();
